// Shared by both forks.
import React, { useCallback, useReducer } from 'react';
import type { SelectedSearchOption } from '../helpers/types';
import type { SelectedResultsCategory } from '../redesign/constants';
import { initialSearchState, searchReducer } from './searchReducer';

// Called first in each root, so every hook after it can read or dispatch. The setters keep the
// useState shape the contexts expose.
export function useSearchState() {
	const [state, dispatch] = useReducer(searchReducer, initialSearchState);

	const setSearchTerm = useCallback(
		(term: React.SetStateAction<string>) => dispatch({ type: 'termChanged', term }),
		[],
	);
	const setSelectedSearchOptions = useCallback(
		(options: React.SetStateAction<SelectedSearchOption[]>) =>
			dispatch({ type: 'searchOptionsChanged', options }),
		[],
	);
	const setSelectedResultsCategory = useCallback(
		(category: React.SetStateAction<SelectedResultsCategory>) =>
			dispatch({ type: 'resultsCategoryChanged', category }),
		[],
	);

	return {
		...state,
		dispatch,
		setSearchTerm,
		setSelectedSearchOptions,
		setSelectedResultsCategory,
	};
}
